import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEmailSetting = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 22,
	height: 20,
	viewBox: "0 0 22 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.53517 17H9.00001C6.19975 17 4.79962 17 3.73006 16.455C2.78925 15.9757 2.02435 15.2108 1.54498 14.27C1.00001 13.2004 1.00001 11.8003 1.00001 9C1.00001 7.00596 1.00001 5.72189 1.19679 4.76159M20.8032 4.76159L15.295 8.26682C13.7385 9.25734 12.9602 9.7526 12.1238 9.94553C11.3843 10.1161 10.6157 10.1161 9.87624 9.94553C9.03982 9.7526 8.26154 9.25734 6.705 8.26681L1.19679 4.76159M20.8032 4.76159C20.7237 4.37332 20.6119 4.03798 20.455 3.73005C19.9757 2.78924 19.2108 2.02433 18.27 1.54497C17.2004 1 15.8003 1 13 1H9.00001C6.19975 1 4.79962 1 3.73006 1.54497C2.78925 2.02433 2.02435 2.78924 1.54498 3.73005C1.38808 4.03798 1.27635 4.37332 1.19679 4.76159M20.8032 4.76159C20.9778 5.61353 20.9975 6.7203 20.9997 8.35157M17 15H17.01M17 11L18.1787 12.1545L19.8284 12.1716L19.8456 13.8213L21 15L19.8456 16.1787L19.8284 17.8284L18.1787 17.8455L17 19L15.8213 17.8455L14.1716 17.8284L14.1545 16.1787L13 15L14.1545 13.8213L14.1716 12.1716L15.8213 12.1545L17 11Z",
		stroke: "#111111",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgEmailSetting);
export default ForwardRef;
